import "./../styles/service.css";
import React from 'react';
// import React from 'react';
const DigitalTwin = () => {
  return (
    <div className="service">
      <img src="/assets/service.png" alt="服务能力" />
      <div className="title">
        <div className="titleBefore">智盾云链产品系列</div>
        <div className="titleEnd">CLOUD CHAIN</div>
        <div className="temp"></div>
      </div>

      <div className="content">
        <div className="content-title">产品介绍</div>
        <div className="content-content">
          云网数智国内首创智盾云链安全服务体系，作为安全解决方案的核心，秉承开放性和模块化理念，支持多厂商安全产品协同。
        </div>
        <div className="content-title">产品价值</div>
        <div className="content-content">
          智盾云链在等保2.0环境中，基于先进的网络虚拟化技术，通过智能流量管理和调度，预先筛选非关键流量，有效降低安全设备负载，充分发挥安全资源效能，打破云计算、网络和安全之间的壁垒，实现异构安全产品的无缝联动。{" "}
        </div>
        <div className="content-title">产品优势</div>
        <div className="content-content">
          云网数智以智盾云链为核心，整合各类网络功能虚拟化(NFV)产品，实现全方位的安全态势感知分析与可视化呈现。基于稳定可靠的高性能硬件平台，搭载创新的模块化操作系统，支持高达40G/100G的端口数据交换能力，足以满足各种规模网络环境的设备需求。{" "}
        </div>
        <img src="/assets/cloudChian.png" alt="智盾云链产品" />
        <div className="content-end">
          加入云网合作伙伴，开创新业务，获取技术、资源
        </div>
      </div>
    </div>
  );
};
export default DigitalTwin;
